
let customMeasurements = {};

function openCustomSizeModal() {
  document.getElementById('customSizeModal').style.display = 'block';

  let hasSizePants = document.querySelector('.sidebar-btn[data-category="pants"]') !== null;

  if (hasSizePants) {
    showStep(2, 'pants');
  } else {
    showStep(1);
  }
}

function closeCustomSizeModal() {
  document.getElementById('customSizeModal').style.display = 'none';
}

function showStep(stepNumber, category = null) {
  document.querySelectorAll('.step').forEach(step => {
    step.style.display = 'none';
  });

  const targetStep = document.querySelector(`.step[data-step="${stepNumber}"]`);
  if (targetStep) targetStep.style.display = 'block';

  if (category) {
    document.querySelectorAll('.measurement-form').forEach(form => {
      form.style.display = 'none';
    });

    let targetForm = document.querySelector(`.measurement-form[data-category="${category}"]`);
    if (targetForm) targetForm.style.display = 'block';

    document.querySelectorAll('.sidebar-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.category === category);
    });
  }
}

function addToCart() {
  let properties = {};
  let activeCategory = document.querySelector('.sidebar-btn.active')?.dataset.category || '';

  if (activeCategory === 'blouse' || activeCategory === 'lehenga') {
    let blouseInputs = document.querySelectorAll('.measurement-form[data-category="blouse"] input');
    let lehengaInputs = document.querySelectorAll('.measurement-form[data-category="lehenga"] input');

    blouseInputs.forEach(input => {
      if (input.value) {
        properties[`Blouse - ${input.name.split('-')[1]}`] = input.value;
      }
    });

    lehengaInputs.forEach(input => {
      if (input.value) {
        properties[`Lehenga - ${input.name.split('-')[1]}`] = input.value;
      }
    });
  } else {
    let inputs = document.querySelectorAll(`.measurement-form[data-category="${activeCategory}"] input`);
    inputs.forEach(input => {
      if (input.value) {
        properties[input.name.replace('-', ' ')] = input.value;
      }
    });
  }

  let variantId = document.querySelector('input[name="id"]').value;
  let quantity = document.querySelector('input[name="quantity"]')?.value || 1;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: parseInt(quantity),
        properties: properties
      }]
    })
  })
  .then(response => response.json())
  .then(data => {
    closeCustomSizeModal();
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    if (theme.settings.afterAddToCart === 'drawer') {
      document.querySelector('.js-cart-drawer').open();
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
}

document.querySelectorAll('.category-btn, .sidebar-btn').forEach(button => {
  button.addEventListener('click', (e) => {
    let category = e.target.dataset.category;
    showStep(2, category);
  });
});
